import * as Yup from 'yup';

const formSchema = Yup.object().shape({
 // required for logic branching
  joinOrCreate: Yup.string()
    .oneOf(['join', 'create'], 'Invalid selection')
    .required('Please choose an option'),

  // personal details
  firstName: Yup.string().required('First name is required'),
  lastName: Yup.string().required('Last name is required'),
  fullName: Yup.string().required('Full name is required'),
  gender: Yup.string()
    .oneOf(['male', 'female', 'other'], 'Invalid gender')
    .required('Gender is required'),
  workingExperience: Yup.string(),

  // access ID (required only if joining)
  accessID: Yup.string().when('joinOrCreate', ([val], schema) =>
    val === 'join' ? schema.required('Access ID is required') : schema.notRequired()
  ),

  // company details (required only if creating)
  companyName: Yup.string().when('joinOrCreate', ([val], schema) =>
    val === 'create' ? schema.required('Company name is required') : schema.notRequired()
  ),
  companyCategory: Yup.string().when('joinOrCreate', ([val], schema) =>
    val === 'create' ? schema.required('Company category is required') : schema.notRequired()
  ),
  companyRegNum: Yup.string().when('joinOrCreate', ([val], schema) =>
    val === 'create' ? schema.required('Registration number is required') : schema.notRequired()
  ),
  addressLine1: Yup.string().when('joinOrCreate', ([val], schema) =>
    val === 'create' ? schema.required('Address line 1 is required') : schema.notRequired()
  ),
  addressLine2: Yup.string(),
  city: Yup.string().when('joinOrCreate', ([val], schema) =>
    val === 'create' ? schema.required('City is required') : schema.notRequired()
  ),
  state: Yup.string().when('joinOrCreate', ([val], schema) =>
    val === 'create' ? schema.required('State is required') : schema.notRequired()
  ),
  postalCode: Yup.string().when('joinOrCreate', ([val], schema) =>
    val === 'create' ? schema.required('Postal code is required') : schema.notRequired()
  ),
  country: Yup.string().when('joinOrCreate', ([val], schema) =>
    val === 'create' ? schema.required('Country is required') : schema.notRequired()
  ),
  companySize: Yup.string().when('joinOrCreate', ([val], schema) =>
    val === 'create' ? schema.required('Company size is required') : schema.notRequired()
  ),
  contactNumber: Yup.string().when('joinOrCreate', ([val], schema) =>
    val === 'create'
      ? schema
          .matches(/^\+?[0-9\s\-()]+$/, 'Invalid phone number format')
          .min(5, 'Must be at least 5 digits')
          .required('Contact number is required')
      : schema.notRequired()
  ),
  contactEmail: Yup.string().when('joinOrCreate', ([val], schema) =>
    val === 'create'
      ? schema.email('Invalid email address').required('Email is required')
      : schema.notRequired()
  ),
});

export default formSchema;
